<template>
  <div>
    <div class="page-head">
      <div>
        <h2>佣金方案</h2>
        <p>方案启用后不可覆盖修改，比例调整请创建新版本</p>
      </div>
      <el-button
        type="primary"
        @click="dialog = true"
      >
        <el-icon><Plus /></el-icon>
        新建方案
      </el-button>
    </div>
    <el-card shadow="never">
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="name"
          label="方案名称"
        />
        <el-table-column
          prop="version"
          label="版本"
          width="120"
        />
        <el-table-column
          prop="effective_from"
          label="生效时间"
          width="180"
        />
        <el-table-column
          prop="effective_to"
          label="失效时间"
          width="180"
        />
        <el-table-column
          prop="status"
          label="状态"
        >
          <template #default="{ row }">
            <el-tag :type="row.status === 'ACTIVE' ? 'success' : 'info'">
              {{ row.status === 'ACTIVE' ? '启用' : '草稿' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
        >
          <template #default="{ row }">
            <el-button
              v-if="row.status === 'DRAFT'"
              link
              type="primary"
              @click="activate(row)"
            >
              启用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-empty
        v-if="!loading && !rows.length"
        description="暂无佣金方案"
      />
    </el-card>
    <el-dialog
      v-model="dialog"
      title="新建佣金方案"
      width="520px"
    >
      <el-form
        :model="form"
        label-width="100px"
      >
        <el-form-item
          label="方案名称"
          required
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item
          label="版本号"
          required
        >
          <el-input
            v-model="form.version"
            placeholder="例如 2026-01"
          />
        </el-form-item>
        <el-form-item
          label="生效时间"
          required
        >
          <el-date-picker
            v-model="form.effectiveFrom"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker
            v-model="form.effectiveTo"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.notes"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog = false">取消</el-button>
        <el-button
          type="primary"
          :loading="saving"
          @click="save"
        >
          保存草稿
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { commissionApi } from '../api'
const rows = ref([]),
  loading = ref(false),
  saving = ref(false),
  dialog = ref(false),
  form = reactive({
    name: '',
    version: '',
    effectiveFrom: '',
    effectiveTo: '',
    notes: '',
  })
const load = async () => {
  loading.value = true
  try {
    rows.value = (await commissionApi.listPlans())?.items || []
  } catch (e) {
    ElMessage.error(e?.message || '加载失败')
  } finally {
    loading.value = false
  }
}
const save = async () => {
  if (!form.name || !form.version || !form.effectiveFrom) {
    ElMessage.warning('请填写名称、版本和生效时间')
    return
  }
  saving.value = true
  try {
    await commissionApi.createPlan(form)
    ElMessage.success('方案草稿已创建')
    dialog.value = false
    load()
  } catch (e) {
    ElMessage.error(e?.message || '保存失败')
  } finally {
    saving.value = false
  }
}
const activate = async (row) => {
  try {
    await ElMessageBox.confirm(
      `启用方案 ${row.version}？启用后不能直接覆盖修改`,
      '确认'
    )
    await commissionApi.activatePlan(row.id)
    ElMessage.success('方案已启用')
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
